(function () {
  var form = document.getElementById('contact-form');
  if (!form) return;

  form.querySelectorAll('.form-error').forEach(function (el) {
    el.dataset.defaultMsg = el.textContent;
  });

  form.addEventListener('submit', function (e) {
    var valid = true;
    form.querySelectorAll('[required]').forEach(function (field) {
      var group = field.closest('.form-group');
      var err = group ? group.querySelector('.form-error') : null;
      if (field.type === 'checkbox') {
        if (!field.checked) {
          valid = false;
          if (err) { err.textContent = err.dataset.defaultMsg || 'This field is required.'; err.classList.add('visible'); }
        } else if (err) {
          err.classList.remove('visible');
        }
      } else if (!field.value.trim()) {
        valid = false;
        field.style.borderColor = '#C04040';
        if (err) { err.textContent = err.dataset.defaultMsg || 'This field is required.'; err.classList.add('visible'); }
      } else if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)) {
        valid = false;
        field.style.borderColor = '#C04040';
        if (err) { err.textContent = 'Please enter a valid email address.'; err.classList.add('visible'); }
      } else {
        field.style.borderColor = '';
        if (err) err.classList.remove('visible');
      }
    });
    if (!valid) e.preventDefault();
  });

  form.querySelectorAll('input, textarea, select').forEach(function (field) {
    field.addEventListener('input', function () {
      field.style.borderColor = '';
      var group = field.closest('.form-group');
      var err = group ? group.querySelector('.form-error') : null;
      if (err) err.classList.remove('visible');
    });
  });
})();
